/* eslint-disable sort-keys-fix/sort-keys-fix */
import { FC } from 'react'

import SearchIcon from '@mui/icons-material/Search'
import { Col, Input, Row } from 'components'
import { ExcelIcon, PdfIcon } from 'components/Svg'
import { colorsStatus } from 'components/Icons/StatusIcon/StatusIcon'
import { useAuth, useLoading, useModal, useReportPrint } from 'hooks'
import moment from 'moment'
import {
  MonthlyDocumentsServices,
  PendenciaCollapse
} from 'services/Supplier/ThirdPartyAdministration'
import { COLORS, FORMAT } from 'utils'
import { downloadBase64 } from 'utils/functions'

interface ISearchPendency {
  pesquisaGeralTxt: string | undefined
  pendencias: PendenciaCollapse[]
  setPesquisaGeralTxt: (newValue: string) => void
}
export const SearchPendency: FC<ISearchPendency> = ({
  pesquisaGeralTxt,
  setPesquisaGeralTxt,
  pendencias
}) => {
  const {
    user: { IdUsuario }
  } = useAuth()
  const { setLoading, setMsgErro } = useLoading()
  const { handlePrintDocumentacaoMensalPendencia } = useReportPrint()
  const { showModal } = useModal()

  const generateExcel = () => {
    setLoading('loading')

    MonthlyDocumentsServices()
      .GetExcelPendencia({
        IdUsuario: IdUsuario
      })
      .then((response) => {
        if (response.status === 200) {
          downloadBase64('Relatorio de consulta do fornecedor.xlsx', response.data)
        }

        setLoading('idle')
      })
      .catch(() => {
        // setLoading('error')
        // setMsgErro('Não foi possível obter o documento')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter o documento',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const getStatusColor = (cdStatus: string) => {
    return {
      content: cdStatus || 'Pendente',
      styles: {
        fillColor: colorsStatus[cdStatus],
        fontStyle: 'bold'
      }
    }
  }

  return (
    <Row alignItems="center" justifyContent="space-between">
      <Col>
        {pendencias?.length > 0 && (
          <Row>
            <ExcelIcon onClick={generateExcel} />
            <PdfIcon
              onClick={() =>
                handlePrintDocumentacaoMensalPendencia({
                  filename: `relatório-documentacao-mensal-pendência-${moment().format(
                    'DD-MM-YYYY'
                  )}`,
                  data: pendencias?.map((pendencia) => ({
                    titleCollapse: pendencia.txObjetoContrato,
                    cdContrato: pendencia.cdContrato,
                    empresa: pendencia.nmFornecedor,
                    dataIni: pendencia.dtVigenciaInicio,
                    dataFim: pendencia.dtVigenciaFim,
                    body: pendencia?.anexos.map((anexo) => [
                      anexo.txDescricaoTipo,
                      pendencia.cdContrato,
                      FORMAT.competencia(anexo.competencia),
                      FORMAT.formatDDMMYYYY(anexo.dtAnexado),
                      Math.abs(anexo.diasPendentes),
                      anexo.qtdAnalises,
                      { content: anexo.txJustificativa || '', colSpan: 2 },
                      FORMAT.formatDDMMYYYY(anexo.dtRetorno),
                      getStatusColor(anexo.cdStatus)
                    ])
                  }))
                })
              }
            />
          </Row>
        )}
      </Col>
      <Col>
        <Input
          value={pesquisaGeralTxt}
          onChange={(e) => setPesquisaGeralTxt(e.target.value)}
          formValue="searchGlobal"
          label="Pesquisa Geral"
          maxLength={895}
          placeholder="Nome do fornecedor"
          inputIcon={<SearchIcon style={{ cursor: 'default' }} />}
          disabled={pendencias?.length === 0}
        />
      </Col>
    </Row>
  )
}
